/**
 * Named constants for the API workflow status ids. Ids match the API's enum;
 * the API may still grow statuses the UI doesn't name, so
 * `workflowStatusTypeId` fields stay typed `number` and lookups must handle
 * unknown ids at runtime.
 *
 * TODO: reconcile against the API's full status set (PBI 55577 / DB card
 * 55765 name at least ManualReviewPending, which is missing here). Until
 * then, unrecognized ids render as the neutral "Unknown" badge.
 */
export enum WorkflowStatusType {
  Pending = 1,
  New = 4,
  NeedsInfo = 6,
  InProgress = 7,
}
